import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { Button, Form, Select, DatePicker, Input, Layout, Row, Col } from 'antd'
import { observer, inject } from 'mobx-react'
import * as styles from '../../../App/index.scss'

const Option = Select.Option

@inject((store: any) => {
    const { notifications } = store

    return {
        notifications
    }
})
@observer
class IndexSearch extends ComponentExt<any> {
    updateFilter = (e, filterName) => {
        this.props.notifications.updateFilters({ ...this.props.notifications.filters, [filterName]: e })
    }
    updateAndChange = (e, filterName) => {
        this.updateFilter(e, filterName)
        this.updateList()
    }
    updateList = () => {
        this.props.notifications.getNotifications({ pageIndex: 1 })
    }
    render() {
        return (
            <div className="box">
                <div className="search">
                    <Form>
                        <Layout>
                            <Row gutter={3}>
                                <Col xs={4}>
                                    <Select
                                        className={styles.input}
                                        placeholder={`סינון לפי מצב התראה`}
                                        onChange={e => this.updateAndChange(e, 'read')}
                                    >
                                        <Option key={0} value={null}>
                                            כל ההתראות
                                        </Option>
                                        <Option key={1} value={0}>
                                            התראות שלא נקראו
                                        </Option>
                                        <Option key={2} value={1}>
                                            התראות שנקראו
                                        </Option>
                                    </Select>
                                </Col>
                                <Col xs={4}>
                                    <Select
                                        className={styles.input}
                                        placeholder={`סינון לפי סוג התראה`}
                                        onChange={e => this.updateAndChange(e, 'type')}
                                    >
                                        <Option key={0} value={null}>
                                            כל ההתראות
                                        </Option>
                                        <Option key={1} value={'ALERT'}>
                                            התראות מערכת
                                        </Option>
                                        <Option key={2} value={'UDPATE'}>
                                            התראות על עדכונים
                                        </Option>
                                    </Select>
                                </Col>
                                <Col xs={4}>
                                    <DatePicker
                                        className={styles.input}
                                        style={{ width: '100%' }}
                                        placeholder={`תאריך התחלה`}
                                        onChange={(d, m) => this.updateAndChange(m, 'startDate')}
                                    />
                                </Col>
                                <Col xs={4}>
                                    <DatePicker
                                        className={styles.input}
                                        style={{ width: '100%' }}
                                        placeholder={`תאריך סיום`}
                                        onChange={(d, m) => this.updateAndChange(m, 'endDate')}
                                    />
                                </Col>
                                <Col xs={4}>
                                    <Input
                                        key={`filter-free-search-text`}
                                        placeholder="חיפוש לפי שם, מייל, טלפון"
                                        className={styles.input}
                                        onChange={e => this.updateFilter(e.target.value || null, 'assignedCustomer')}
                                    />
                                </Col>
                                <Col xs={4}>
                                    <Button onClick={this.updateList} className={styles.input} icon="search">
                                        חפש
                                    </Button>
                                </Col>
                            </Row>
                        </Layout>
                    </Form>
                </div>
            </div>
        )
    }
}

export default Form.create()(IndexSearch)
